<span *ngIf="rowData.status === 0">-</span>
<span *ngIf="rowData.status === 1">Sent</span>
<span *ngIf="rowData.status === 2">Delivered</span>
<span *ngIf="rowData.status === 3">Read</span>
<span *ngIf="rowData.status === 4">Deleted</span>

<span *ngIf="rowData.status === 5" class="conversation-content-text">
  <span class="status-dots-main {{renderColorSpan1}} mr-2">
    <span class="status-dots {{renderColorSpan2}}"></span>
  </span>
  <p [appCustomTooltip]="popContent" [tooltipClass]="'custom-tooltip-left'">Failed</p>
</span>

<span *ngIf="rowData.status === 6" class="conversation-content-text">
  <p [appCustomTooltip]="popContentClick" [tooltipClass]="'custom-tooltip-left'" >Clicked</p>
</span>

<ng-template #popContent>
  <div *ngIf="rowData.status === 5 || rowData.status === 7 "
    [innerHTML]="rowData.error.code + ' - ' + rowData.error.title"></div>
</ng-template>

<ng-template #popContentClick>
  <div *ngIf="rowData.status === 6" [innerHTML]="rowData.user_agent"></div>
</ng-template>


<span *ngIf="rowData.status === 7" class="conversation-content-text">
  <span class="status-dots-main {{renderColorSpan1}}">
    <!-- <span class="status-dots {{renderColorSpan2}}"></span> -->
  </span>
  <p [appCustomTooltip]="popContent" [tooltipClass]="'custom-tooltip-left'">Not Sent</p>
</span>
<!-- <span *ngIf="rowData.status === 7" style="white-space: nowrap;"> Not Sent</span> -->
<span *ngIf="rowData.status === 8" class="conversation-content-text">
  Payment pending
</span>
<span *ngIf="rowData.status === 9" class="conversation-content-text">
  Payment captured
</span>
